// getter/setter for uploadSidePanel
import { atom } from "jotai";
import {
  ExpectedSearchParams,
  searchParamsAtom,
  setSearchParamsHelper,
} from "./locationAtom";
import { atomWithReset } from "jotai/utils";
import { UploadReleaseTrackSidePanelView } from "../../stories/screens/CreateReleaseScreen/components/CreateDTCReleaseView/components/AddSongsView/components/AddSongsSidePanel";

export const uploadSidePanelAtom = atom(
  (get) => {
    return get(searchParamsAtom).upload_release_track === "true";
  },
  (get, set, value: boolean) => {
    const key: keyof ExpectedSearchParams = "upload_release_track";
    setSearchParamsHelper(get, set, {
      key,
      value: value ? "true" : "",
      clear: true,
    });
  },
);

export const uploadSidePanelViewAtom = atomWithReset(
  UploadReleaseTrackSidePanelView.UPLOAD_RELEASE_TRACK,
);

uploadSidePanelAtom.debugLabel = "Upload Side Panel Atom";
